<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <el-table :data="email"
                stripe
                highlight-current-row
                :show-header="false"
                class="margin b15"
                style="width: 100%">
        <el-table-column width="150">
          <template slot-scope="scope">
            <b>{{scope.row.label}}</b>
          </template>
        </el-table-column>
        <el-table-column min-width="150">

          <template slot-scope="scope">
            <div v-if="scope.row.key === 'status' || scope.row.key === 'type' ">
                  <span v-for="item in options[scope.row.key]"
                        v-if="scope.row.value === item.value">{{item.label}}</span>
            </div>
            <div v-else-if="scope.row.key === 'name'">{{scope.row.value}}</div>
          </template>

        </el-table-column>
      </el-table>


      <template slot="header">推送记录</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>


      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="send_time"
                         label="推送时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="customer_name"
                         label="客户"
                         min-width="120"></el-table-column>
        <el-table-column prop="recipient"
                         label="收件人"
                         min-width="120"></el-table-column>
        <el-table-column prop="email"
                         label="收件邮箱"
                         min-width="120"></el-table-column>
        <el-table-column prop="status"
                         label="投递状态"
                         min-width="120">
          <template slot-scope="scope">
          <span v-for="item in options.pushStatus"
                v-if="scope.row.status === item.value">{{item.label}}</span>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      email: [
        {
          key: 'name',
          label: '名称:',
          value: '',
        },
        {
          key: 'type',
          label: '类型:',
          value: '',
        },
        {
          key: 'status',
          label: '状态:',
          value: 0,
        },
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.satisfactionEmail.options,
    }),
  },
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    setDetailData (id) {
      request.page('getSatisfactionEmailDetail', {id}).then(({data}) => {
        this.email.forEach(obj => {
          if (data[obj.key]) {
            obj.value = data[obj.key]
          }
        })
      })
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      if (this.$route.params.id) {
        params.id = this.$route.params.id
      }
      params = filter.copyJson(params)
      return request.page('getSatisfactionEmailPushLogTable', params)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/satisfaction-email/pages/SatisfactionEmailPushLog.vue